import { Component, OnInit, Input } from '@angular/core';
import { TranslationService } from '../../shared/index';
import { FormElementListing } from '../shared/model/listing/form-element-listing.model';
import { FormBuilderComponent } from '../form-builder.component';

@Component({
  selector: 'wl-form-builder-listing-display-element',
  templateUrl: 'form-builder-listing-display-element.component.html',
    standalone: false
})
export class FormBuilderListingDisplayElementComponent {
  @Input('listingSettings') listingSettings: FormElementListing;
  private _translationService: TranslationService;

  public constructor(translationService: TranslationService) {
    this._translationService = translationService;
  }

  ngOnInit(): void {}
}
